import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alertlanding',
  templateUrl: './alertlanding.component.html',
  styleUrls: ['./alertlanding.component.scss']
})
export class AlertlandingComponent implements OnInit {

  constructor() { }
  public numerovisitatori: number;
  public numeroattivati: number;
  private max = 100;
  private min = 10;
  private maxat = 5;
  private minat = 1;
  private MaxContratti = 100;
  ngOnInit() {
    this.numerovisitatori = 10;
    this.numeroattivati = 2;
    this.calcolavisitatori();
    this.calcolaattivati();
    setInterval(() => this.calcolavisitatori(), 15000);
    setInterval(() => this.calcolaattivati(), 120000);
    
  }

  calcolavisitatori() {
    this.numerovisitatori = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;

  }
  calcolaattivati() {
    var t = new Date();
    var mill = (t.getHours() * 3600 * 1000) + (t.getMinutes() * 60 * 1000) + t.getSeconds() * 1000;
    
    this.numeroattivati =Math.round( this.MaxContratti * ( mill /(3600 * 24 * 1000)  ));

  }
}



// WEBPACK FOOTER //
// ./src/app/alertlanding/alertlanding.component.ts